/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cozy_Long_Cuckoo_AscendInputs */

const en_cozy_long_cuckoo_ascend = /** @type {(inputs: Cozy_Long_Cuckoo_AscendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Light`)
};

const de_cozy_long_cuckoo_ascend = /** @type {(inputs: Cozy_Long_Cuckoo_AscendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hell`)
};

/**
* | output |
* | --- |
* | "Light" |
*
* @param {Cozy_Long_Cuckoo_AscendInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cozy_long_cuckoo_ascend = /** @type {((inputs?: Cozy_Long_Cuckoo_AscendInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cozy_Long_Cuckoo_AscendInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cozy_long_cuckoo_ascend(inputs)
	return de_cozy_long_cuckoo_ascend(inputs)
});